import {
    AmrapResult,
    MaxTimeResult,
    Team,
    TeamWodResult,
    TimeCapResult,
    WeightResult,
    Wod,
    WodCat,
    WodType
} from "./types";
import {participantsRX, participantsScale} from "./participants"

const toAmrapTeamWodResult = (teams: Team[]): TeamWodResult[] => {
    return teams.map(t => ({team: t, points: 0, ranking: 1, result: {reps: 0} as AmrapResult}))
}

const toTimeCapTeamWodResult = (teams: Team[]): TeamWodResult[] => {
    return teams.map(t => ({
        team: t,
        points: 0,
        ranking: 1,
        result: {reps: 0, mins: 0, seconds: 0, cap: false} as TimeCapResult
    }))
}

const toWeightTeamWodResult = (teams: Team[]): TeamWodResult[] => {
    return teams.map(t => ({team: t, points: 0, ranking: 1, result: {weight: 0} as WeightResult}))
}

const toMaxTimeTeamWodResult = (teams: Team[]): TeamWodResult[] => {
    return teams.map(t => ({
        team: t,
        points: 0,
        ranking: 1,
        result: {mins: 0, seconds: 0} as MaxTimeResult
    }))
}

const toTeamWodResult = (wodType: WodType, teams: Team[]): TeamWodResult[] => {
    switch (wodType){
        case WodType.MAXTIME: return toMaxTimeTeamWodResult(teams);
        case WodType.AMRAP: return toAmrapTeamWodResult(teams);
        case WodType.TIMECAP: return toTimeCapTeamWodResult(teams);
        case WodType.WEIGHT: return toWeightTeamWodResult(teams);
    }
}

//EVENT 1 Double Hang
const wod1Scale: Wod = {
    results: toTeamWodResult(WodType.TIMECAP, participantsScale),
    category: WodCat.SCALE,
    name: "Event 1: Double Hang (Scale)",
    type: WodType.TIMECAP
}
const wod1RX: Wod = {
    results: toTeamWodResult(WodType.TIMECAP, participantsRX),
    category: WodCat.RX,
    name: "Event 1: Double Hang (RX)",
    type: WodType.TIMECAP
}

//EVENT 2: Clean Assault
const wod2Scale: Wod = {
    results: toTeamWodResult(WodType.TIMECAP, participantsScale),
    category: WodCat.SCALE,
    name: "Event 2: Clean Assault (Scale)",
    type: WodType.TIMECAP
}
const wod2RX: Wod = {
    results: toTeamWodResult(WodType.TIMECAP, participantsRX),
    category: WodCat.RX,
    name: "Event 2: Clean Assault (RX)",
    type: WodType.TIMECAP
}

// EVENT 3.1: Skill Test
const wod31Scale: Wod = {
    results: toTeamWodResult(WodType.MAXTIME, participantsScale),
    category: WodCat.SCALE,
    name: "Event 3.1: Skill Test (Scale)",
    type: WodType.MAXTIME
}
const wod31RX: Wod = {
    results: toTeamWodResult(WodType.MAXTIME, participantsRX),
    category: WodCat.RX,
    name: "Event 3.1: Skill Test (RX)",
    type: WodType.MAXTIME
}

// Event 3.2: Boxes, Walls and Ropes
const wod32Scale: Wod = {
    results: toTeamWodResult(WodType.AMRAP, participantsScale),
    category: WodCat.SCALE,
    name: "Event 3.2: Boxes, Walls and Ropes (Scale)",
    type: WodType.AMRAP
}
const wod32RX: Wod = {
    results: toTeamWodResult(WodType.AMRAP, participantsRX),
    category: WodCat.RX,
    name: "Event 3.2: Boxes, Walls and Ropes (RX)",
    type: WodType.AMRAP
}


export {wod1Scale, wod2Scale, wod31Scale, wod32Scale, wod1RX, wod2RX, wod31RX, wod32RX}